import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

// Base selector
export const selectReviewCR = (state: RootState) => state.reviewCR;

// Current editing CR
export const selectCurrentEditingCR = createSelector(
  selectReviewCR,
  (reviewCR) => reviewCR.current_editing_cr
);

// UI state selectors
export const selectUIState = createSelector(
  selectReviewCR,
  (reviewCR) => reviewCR.ui_state
);

export const selectSearchQuery = createSelector(
  selectUIState,
  (uiState) => uiState.search_query
);

export const selectSortBy = createSelector(
  selectUIState,
  (uiState) => uiState.sort_by
);

export const selectSortOrder = createSelector(
  selectUIState,
  (uiState) => uiState.sort_order
);

export const selectDateRange = createSelector(
  selectUIState,
  (uiState) => uiState.filter_by_date_range
);

// Loading states
export const selectLoadingStates = createSelector(
  selectReviewCR,
  (reviewCR) => reviewCR.loading
);

export const selectIsSaving = createSelector(
  selectLoadingStates,
  (loading) => loading.save
);

export const selectIsDeleting = createSelector(
  selectLoadingStates,
  (loading) => loading.delete
);

export const selectIsFetching = createSelector(
  selectLoadingStates,
  (loading) => loading.fetch
);

// Error states
export const selectErrorStates = createSelector(
  selectReviewCR,
  (reviewCR) => reviewCR.errors
);

export const selectSaveError = createSelector(
  selectErrorStates,
  (errors) => errors.save
);

export const selectDeleteError = createSelector(
  selectErrorStates,
  (errors) => errors.delete
);

export const selectFetchError = createSelector(
  selectErrorStates,
  (errors) => errors.fetch
);

// Server-paginated CRs — returns the current page's data directly from db_crs
// (filtering, sorting, and pagination are handled server-side)
export const selectPaginatedCRs = createSelector(
  [(state: RootState) => state.database.db_crs],
  (crs) => crs,
);